import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '../../services/permissions/permissions.service';

/**
 * Restricts a route to Synectics-internal users (an @synx.com login). Runs after authGuard, so a
 * valid token is already present; a non-synx user is redirected to the app root. The Usage endpoint
 * behind the page is independently gated by SynxEmailPolicy, so this is a UX gate, not the security
 * boundary.
 */
export const synxGuard: CanActivateFn = () => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  if (!permissions.username) {
    permissions.setRolesFromToken();
  }

  if (permissions.isSynxInternal) {
    return true;
  }

  return router.parseUrl('/');
};
